import api from "./client";

/**
 * تحميل ملف من API مع إرسال cookies (JWT)
 */
export async function downloadApiFile(path: string, filename?: string): Promise<void> {
  const res = await api.get(path, { responseType: "blob" });
  const blob = res.data as Blob;
  const disposition = res.headers["content-disposition"] as string | undefined;
  let name = filename ?? "export.csv";
  if (disposition) {
    const m = /filename="?([^";]+)"?/.exec(disposition);
    if (m?.[1]) name = m[1];
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
